import React, { Component } from 'react';
import _memoize from 'lodash.memoize';
import FiltersGroupContainer from './FiltersGroupContainer';
import RadioButton from '../../RadioButtons/components/RadioButton';
import { getRadioChange, isRadioChecked } from '../helpers';
import FiltersGroupLabel from './FiltersGroupItemLabel';





















function filterIsChecked({ selectedValues, value, shouldReturnOptionAllSelection }) {
  return isRadioChecked(value, selectedValues, shouldReturnOptionAllSelection);
}

export default class RadioFiltersGroup extends Component {
  handleFilterChange = _memoize((
  { value }) =>
  () => {
    const { onChange, shouldReturnOptionAllSelection } = this.props;

    const changes = getRadioChange(
      value,
      shouldReturnOptionAllSelection
    );
    return onChange(changes);
  });

  static defaultProps = {
    selectedValues: []
  };

  render() {
    const {
      filterFacets,
      label: groupLabel,
      isCollapsible,
      openedByDefault,
      selectedValues,
      minWidth,
      stats,
      shouldReturnOptionAllSelection
    } = this.props;
    return (
      <FiltersGroupContainer
        label={groupLabel}
        isCollapsible={isCollapsible}
        openedByDefault={openedByDefault}
        minWidth={minWidth}>

        {filterFacets.map(({ label, value, disabled, statKey }) =>
        <RadioButton
          key={value}
          value={value}
          disabled={disabled}
          selected={Boolean(filterIsChecked({
            selectedValues,
            value,
            shouldReturnOptionAllSelection
          }))}
          onChange={this.handleFilterChange({ value })}>

            <FiltersGroupLabel
            label={label}
            stats={stats}
            statKey={statKey} />

          </RadioButton>
        )}
      </FiltersGroupContainer>);

  }
}